import { Link } from "@chakra-ui/react";
import { useQuery } from "react-query";
import { Link as RouterLink, Outlet, useParams } from "react-router-dom";

import { AuthService } from "src/common/AuthService";
import { HTTPError, useKy } from "src/common/ky";
import { Loading } from "src/common/Loading";
import PageHeaderError from "src/common/PageHeaderError";
import {
  DealerOrganization as DealerOrganizationType,
  StaffRole,
} from "src/common/types";
import {
  PageHeader,
  PageHeaderBackLink,
  PageHeaderTabs,
  PageHeaderTitle,
} from "src/layout/PageHeader";
import { TabLink } from "src/layout/TabLink";

export const DealerOrganization = () => {
  const { id } = useParams<"id">();
  const ky = useKy();
  const query = useQuery<DealerOrganizationType, HTTPError>(
    `DEALER_ORGANIZATIONS:${id}`,
    () => ky.get(`dealer-organizations/${id}`).json<DealerOrganizationType>()
  );
  const role = AuthService.hooks.useStaffUserRole();

  if (query.isError) {
    return (
      <PageHeaderError
        statusCode={query.error.response.status}
        statusText={query.error.response.statusText}
      />
    );
  }

  if (query.isLoading || !query.isSuccess) {
    return <Loading />;
  }

  const data = query.data;

  return (
    <>
      <PageHeader>
        <PageHeaderBackLink>
          <Link as={RouterLink} to={"/dealers"}>
            &#8249; Back to list
          </Link>
        </PageHeaderBackLink>
        <PageHeaderTitle>{data.name}</PageHeaderTitle>
        <PageHeaderTabs>
          <TabLink
            key="dealers"
            to={`/dealers/${id}/details`}
            label="Details"
            end
          />
          {role === StaffRole.Admin && (
            <>
              <TabLink
                key="financials"
                to={`/dealers/${id}/financials`}
                label="Financials"
                end
              />
              <TabLink
                key="users"
                to={`/dealers/${id}/users`}
                label="Staff"
                end
              />
            </>
          )}
          <TabLink
            key="properties"
            to={`/dealers/${id}/properties`}
            label="Properties"
            end
          />
        </PageHeaderTabs>
      </PageHeader>

      <Outlet />
    </>
  );
};
